import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Grid, Card, Button, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { wrapper } from "utils/wrapper";
import { useSoftUIController } from "hooks/context";

// Imports
import LiveMonitorList from "./LiveMonitorList"; // We will rename LiveMonitorTab to this
import LiveTripChart from "./LiveTripChart";

function StopFeedCompareView({ user }) {
  const [controller] = useSoftUIController();
  const stopId = "2000167";
  
  // Master state for the selected trip
  const [selectedMatchKey, setSelectedMatchKey] = useState(null);

  // Responsive state handlers
  const handleSelectTrip = (matchKey) => {
    setSelectedMatchKey(matchKey);
  };

  const handleClearSelection = () => {
    setSelectedMatchKey(null);
  };

  return wrapper(
    <SoftBox mt={2} sx={{ height: "calc(100vh - 100px)", overflow: "hidden" }}>
      <Grid container spacing={3} sx={{ height: "100%" }}>
        
        {/* LEFT COLUMN: Live List (Hidden on mobile if a trip is selected) */}
        <Grid 
          item xxs={12} md={4} 
          sx={{ 
            height: "100%", 
            display: { xxs: selectedMatchKey ? "none" : "block", md: "block" } 
          }}
        >
          <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <LiveMonitorList 
              stopId={stopId} 
              onSelectTrip={handleSelectTrip}
              selectedMatchKey={selectedMatchKey} 
            />
          </Card>
        </Grid>

        {/* RIGHT COLUMN: Live Auto-Refreshing Chart (Hidden on mobile if no trip selected) */}
        <Grid 
          item xxs={12} md={8} 
          sx={{ 
            height: "100%", 
            display: { xxs: selectedMatchKey ? "block" : "none", md: "block" } 
          }}
        >
          <Card sx={{ height: "100%", p: 2 }}>
            {selectedMatchKey ? (
              <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                {/* Mobile Back Button */}
                <Box sx={{ display: { xxs: "flex", md: "none" }, mb: 2 }}>
                  <Button 
                    startIcon={<ArrowBackIcon />} 
                    onClick={handleClearSelection}
                    variant="contained"
                    size="small"
                  >
                    Back to Live List
                  </Button>
                </Box>
                
                <LiveTripChart stopId={stopId} matchKey={selectedMatchKey} />
              </Box>
            ) : (
              <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <SoftTypography variant="h6" color="textSecondary">
                  Select a live trip to view real-time analysis
                </SoftTypography>
              </Box>
            )}
          </Card>
        </Grid>

      </Grid>
    </SoftBox>,
    controller
  );
}

StopFeedCompareView.propTypes = { user: PropTypes.object };
export default StopFeedCompareView;